import { useMemo } from 'react'
import { GroupsStatusTabs, IGroupEntity } from '../../../models/IGroup'
import { mapGroupStatusToTab } from '../constants/groupStatuses'

type UseGroupsAvailabilityArgs = {
	groupsByBarns?: IGroupEntity[]
	groupsByStatuses?: IGroupEntity[]
	currentBarns: (string | number)[]
}

export const useGroupsAvailability = ({
	groupsByBarns,
	groupsByStatuses,
	currentBarns,
}: UseGroupsAvailabilityArgs) => {
	const availableStatuses = useMemo(() => {
		if (currentBarns.length === 0) return null

		if (!groupsByBarns || groupsByBarns.length === 0) return null

		return new Set(
			groupsByBarns
				.filter(
					group =>
						group.barn !== null &&
						group.barn !== undefined &&
						currentBarns.includes(group.barn),
				)
				.map(group => mapGroupStatusToTab(group.status))
				.filter(Boolean) as GroupsStatusTabs[],
		)
	}, [groupsByBarns, currentBarns])

	const availableBarns = useMemo(() => {
		if (!groupsByStatuses || groupsByStatuses.length === 0) return null
		return new Set(groupsByStatuses.map(g => g.barn))
	}, [groupsByStatuses])

	return { availableStatuses, availableBarns }
}
